var wellKnownSymbol = require('../internals/well-known-symbol');

exports.f = wellKnownSymbol;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/well-known-symbol-wrapped.js
// module id = 149
// module chunks = 0 1